'use client';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { trackPageView } from '../../utils/gtm';

export default function GTMPageView() {
  const pathname = usePathname();

  useEffect(() => {
    if (pathname) {
      // Get page title from document or generate from pathname
      const pageTitle = document.title || pathname?.replace(/\//g, ' ')?.trim() || 'Home';
      trackPageView(pathname, pageTitle);
    }
  }, [pathname]);

  return null;
}